import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

$(document).ready( function () {
    const swiper = new Swiper('#author-slider', {
        effect: "coverflow",
        grabCursor: true,
        loop: true,
        loopAdditionalSlides: 3,
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true
        },
        init : true,
        initialSlide: 2,
        dragFreeMode: false,
        spaceBetween: 0,
        centeredSlides: true,
        modules: [Pagination, Autoplay],
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true
        },
        slidesPerView: 5,
        breakpoints: {
            570: {
                slidesPerView: 6,
            },
            1024: {
                slidesPerView: 6,
            },
            1820: {
                slidesPerView: 6,
            },
        },
        on: {
            init: function () {
                $('#author-slider').removeClass('hidden')
                changeAuthorName(this.slides[this.activeIndex])
                setAuthorUrl($(this.slides[this.activeIndex]).data('url'))
            },
            transitionStart: function () {
                changeZIndexes(this.activeIndex, this);
            },
            transitionEnd: function () {
                changeAuthorName(this.slides[this.activeIndex])
                setAuthorUrl($(this.slides[this.activeIndex]).data('url'))
            }
        }
    })

    function changeZIndexes(activeIndex, swiper) {
        let elements = swiper.slides;
        let zindex0 = 1;
        for (let i = 0; i < elements.length; i++) {
            if(i === activeIndex){
                elements[i].style.removeProperty('z-index');
                break;
            }
            elements[i].style.setProperty('z-index', zindex0, 'important');
            zindex0++;
        }
        let zindex1=1;
        for (let ii = elements.length-1; ii > 0; ii--) {
            if(ii === activeIndex){
                elements[ii].style.removeProperty('z-index');
                break;
            }
            elements[ii].style.setProperty('z-index', zindex1, 'important');
            zindex1++;
        }
    }
    function changeAuthorName(activeElement) {
        let authorName = $(activeElement).data('author');
        $('#author-name').html(authorName)
    }

    function setAuthorUrl(authorUrl) {
        $('#author-btn').attr('href', authorUrl)
    }
})
